import { Component, AfterViewInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { AgEditorComponent } from 'ag-grid-angular';
import { ICellEditorParams } from 'ag-grid-community';
import { ME_Fit } from 'me-fit-typings';
import { ExerciseSearchComponent } from '../exercise-search/exercise-search.component';

export type ExerciseSearchOptionValue = ME_Fit.Exercise;

@Component({
  selector: 'app-exercise-cell-search',
  templateUrl: './exercise-cell-search.component.html',
  styleUrls: ['./exercise-cell-search.component.css'],
})
export class ExerciseCellSearchComponent
  implements AgEditorComponent, AfterViewInit
{
  searchCtrl = new FormControl();

  @ViewChild(ExerciseSearchComponent, { static: false })
  exerciseSearchComponent: ExerciseSearchComponent;

  private params: ICellEditorParams;

  constructor() {}

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.exerciseSearchComponent.setFocus();
    }, 100);
  }

  getValue() {
    console.log(
      `[ExerciseCellSearchComponent:getValue] `,
      this.searchCtrl.value
    );
    return this.searchCtrl.value;
  }

  ngOnInit() {}

  agInit(params: ICellEditorParams) {
    console.log('[ExerciseCellSearchComponent:agInit] params', params.value);

    this.searchCtrl.setValue(params.value);

    this.params = params;
  }

  stopEditing() {
    this.params.stopEditing();
  }
}
